var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useCallback, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './MainFilter.scss';
import { getImage } from '../../utils/utils';
import { getDateFilterDesc } from '../../utils/CalendarUtils';
import { photos, CHECKIN_CHECKOUT_ENUM } from '../../res/constants';
import Image from '@hfe/max-image';
import TextInput from '@hfe/max-textinput';
import { useDispatch, useSelector } from '@max/max-redux';
import Sensor from '@max/mbc-sensor';
import { Actions } from '../../store/index';
import { useEffect, useState } from '@hfe/max';
import { useThrottle } from '../../hooks/useThrottle';
import { isAndroid, useEngineContext } from '../../utils/utils';
const isWeb = true;
const isMRN = false;
import { eventOn, eventOff } from '@max/meituan-uni-event';
import { LX_CONFIG } from '../../constants';
import { useMonitorJumper } from '../../hooks/useMonitorJumper';
import { isMeituanAppOrWebview, isDianpingAppOrWebview } from '@nibfe/mkt-env-api';
const ACTION_KEY = 'tex_max_hotel_i_list_city_change';
function shortenCityText(label = '') {
    if (label.length > 3)
        return label.slice(0, 3) + '...';
    else
        return label;
}
function MainFilter(props) {
    const dispatch = useDispatch();
    const ctx = useEngineContext();
    const { monitorNavigateToSmart } = useMonitorJumper();
    const { _LXReport, _moduleId } = ctx;
    const calendarDateRange = useSelector(state => ({
        endDate: state.calendar.endDate,
        startDate: state.calendar.startDate
    }));
    const cityInfo = useSelector(state => state.citySelection.city);
    const toggleCalendarPanel = () => {
        dispatch({
            type: Actions.toggleCalendarPanel
        });
    };
    const toggleCitySelection = () => {
        dispatch({
            type: Actions.toggleCitySelection,
            data: true
        });
    };
    // const jumpToCityList = () => {
    //   const baseUrl = IS_DP ?
    //     'dianping://mrn' :
    //     'imeituan://www.meituan.com/mrn'
    //   let params: any = {
    //     mrn_biz: 'hotel',
    //     mrn_entry: 'hotel-city',
    //     mrn_component: 'hotel-city',
    //     city_type: 1,
    //     from_local_front: false
    //   };
    //   if (isAndroid) {
    //     params = {
    //       ...params,
    //       'city_knb_publish_key': ACTION_KEY,
    //       'city_linkage_mode': 'needPublish'
    //     }
    //   }
    //   const url = baseUrl + queryStr(params);
    //   navigateTo({ url }).then(res => {
    //     const { resultData } = res || {};
    //     try {
    //       const { cityId, cityName } = JSON.parse(resultData) || {};
    //       dispatch({
    //         type: Actions.updateCitySelection,
    //         data: {
    //           label: cityName,
    //           value: cityId,
    //         },
    //       });
    //     } catch (err) {
    //       console.warn('max-hotel-i-list 城市切换解析失败');
    //     }
    //   });
    // }
    const initText = useSelector(state => state.searchText.searchText);
    const initPlaceHolder = useSelector(state => state.searchText.placeholder);
    const [searchText, setSearchText] = useState(initText);
    const isInMt = isMeituanAppOrWebview();
    const isInDp = isDianpingAppOrWebview();
    if (isAndroid) {
        useEffect(() => {
            eventOn({
                action: ACTION_KEY,
                handle: resultData => {
                    try {
                        const { cityId, cityName } = (resultData === null || resultData === void 0 ? void 0 : resultData.data) || {};
                        dispatch({
                            type: Actions.updateCitySelection,
                            data: {
                                label: cityName,
                                value: cityId
                            }
                        });
                    }
                    catch (err) {
                        console.warn('max-hotel-i-list 城市切换解析失败');
                    }
                }
            });
            return () => {
                eventOff({
                    action: ACTION_KEY,
                    subId: null
                });
            };
        }, []);
    }
    useThrottle(650, () => {
        // console.log('searchText', searchText);
        // 添加用户输入文字节流
        dispatch({
            type: Actions.UpdateSearchText,
            data: searchText.trim()
        });
    }, [searchText]);
    // 同步其他组件dispatch 发生的变化
    useEffect(() => {
        // console.log('searchText 同步其他组件dispatch');
        setSearchText(initText);
    }, [initText]);
    const placeholder = useMemo(() => {
        let result = initPlaceHolder;
        if (result && result.length >= 7) {
            result = `${result.trim().slice(0, 5)}...`;
        }
        return initPlaceHolder ? `试试"${result}"` : '位置/房型/设施';
        ;
    }, [initPlaceHolder]);
    const clearSearchText = useCallback(() => {
        // dispatch({ type: Actions.UpdateSearchText, data: '' });
        setSearchText('');
    }, [searchText]);
    const textinputStyle = isAndroid && isMRN ? {
        paddingBottom: '10rpx',
        paddingTop: '10rpx'
    } : {};
    const calendarData = useSelector(state => state.calendar);
    const onCityMV = () => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport(LX_CONFIG.CITY_MV_BID, {
            valLab: {
                _moduleId,
                city_id: cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.value,
                city_name: cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.label
            }
        });
    };
    const onClickSearch = () => {
        var _a, _b;
        const checkInDate = (_a = calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.startDate) === null || _a === void 0 ? void 0 : _a.indexKey;
        const checkOutDate = (_b = calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.endDate) === null || _b === void 0 ? void 0 : _b.indexKey;
        const cityId = cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.value;
        const queryWord = searchText ? searchText : initPlaceHolder || '';
        const urlPrefix = isMeituanAppOrWebview() ? 'imeituan://www.meituan.com/hotel/list?mrn_biz=hotel&mrn_entry=rn-hotel-mainlist&mrn_component=hotel-mainlist' : 'dianping://mrn?mrn_biz=hotel&mrn_entry=rn-hotel-mainlist&mrn_component=hotel-mainlist';
        const jumpUrl = `${urlPrefix}&cityId=${cityId}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&q=${queryWord}`;
        monitorNavigateToSmart(jumpUrl);
    };
    const onSearchInputClick = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        if (!false) {
            return;
        }
        const checkInDate = (_a = calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.startDate) === null || _a === void 0 ? void 0 : _a.indexKey;
        const checkOutDate = (_b = calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.endDate) === null || _b === void 0 ? void 0 : _b.indexKey;
        const params = {
            isHourRoom: false,
            city_id: cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.value,
            checkInDate: checkInDate ? isInMt ? checkInDate : checkInDate.replace(/-/g, '') : '',
            // NOTE:搜索中间页，目前没有支持住离日期透传，所以这里参数无意义
            checkOutDate: checkOutDate ? isInMt ? checkOutDate : checkOutDate.replace(/-/g, '') : '',
            searchText: searchText || '',
            isFromFlight: false,
            fromPageType: 'front',
            // 来源页面类型
            // sourceType: isInMt ? 'hotel' : 'highQuality',
            sourceType: 'hotel',
            // cate: 20,
            overridePendingTransition: true
        };
        const queryStr = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        const meituanUrlPrefix = 'imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=hotelchannel-search&mrn_component=hotelchannel-search';
        const dianpingUrlPrefix = 'dianping://mrn?mrn_biz=hotel&mrn_entry=hotelchannel-search&mrn_component=hotelchannel-search';
        const jumpUrl = `${isInMt ? meituanUrlPrefix : dianpingUrlPrefix}&${queryStr}`;
        monitorNavigateToSmart(jumpUrl);
    });
    return <View className="main-filter-container">
      <View className="round-bar-container">
        {<View className="main-filter-location-container" onClick={toggleCitySelection}>
            <Sensor once onAppear={onCityMV}>
              <Text className="main-filter-location-text">{shortenCityText(cityInfo.label)}</Text>
            </Sensor>
            
          </View>}
        <View x-if={!props.isCommonCityChangeAndSearch} className="main-filter-text-container" onClick={toggleCalendarPanel}>
          <Text className="main-filter-left-text">住</Text>
          <Text className="main-filter-left-text">离</Text>
        </View>
        <View x-if={!props.isCommonCityChangeAndSearch} className="main-filter-date-container" onClick={toggleCalendarPanel}>
          <Text className="main-filter-date-text">
            {getDateFilterDesc(calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.startDate, calendarData, CHECKIN_CHECKOUT_ENUM.CHECKIN)}
          </Text>
          <Text className="main-filter-date-text">
            {getDateFilterDesc(calendarDateRange === null || calendarDateRange === void 0 ? void 0 : calendarDateRange.endDate, calendarData, CHECKIN_CHECKOUT_ENUM.CHECKOUT)}
          </Text>
        </View>
        <View className="main-filter-vertical-line"/>
        <Image x-if={!searchText} className="main-filter-search-icon" source={getImage(photos.SEARCH_ICON)}/>
        <View className="search-input-wrap">
          <TextInput x-if={!props.isCommonCityChangeAndSearch} className="main-filter-input" placeholderColor="#999999" numberOfLines={1} placeholder={placeholder} value={searchText} style={textinputStyle} controlled onChangeText={(text) => setSearchText(text)}/>
          <Text x-else className="main-filter-input" style={{
        color: '#999'
    }} onClick={toggleCitySelection}>搜索城市</Text>
          
        </View>
        <View x-if={(!props.isShowSearchButton || isWeb) && searchText && searchText.length > 0} className="main-filter-clear-text" onClick={clearSearchText}>
          <Image className="main-filter-clear-icon" source={getImage(photos.CLOSE_ICON)}/>
        </View>
        
      </View>
    </View>;
}
export default memo(MainFilter);
